module.exports = __webpack_public_path__ + "static/media/015.f5a26a35.jpg";